import type { FaireProductEntity } from "../../entity_types/product";

export const p_qv5ajws2wg: FaireProductEntity = {
  token: "p_qv5ajws2wg",
  type: "product",
  name: "Timeless Solid Color Long Sleeve Open-Front Blazer",
  brandToken: "b_9rvhvqmmsv",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/ad1219713bfcaaaf752a2318ac3d7c4150c1ab105ccf1c0bd31de2e6bad24757.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4442da761afb25c35ee75669bb2c5c68a373674c8af365d47485f4f0384e319f.jpeg",
    "https://cdn.faire.com/fastly/799ae640fc4f9050820ebf8dbb22e2c5dc0998e18386c368d91e31ac8e3b6565.jpeg",
    "https://cdn.faire.com/fastly/a58223f9c692ceda71d7e1279e474a767882c59708c4b7c737995829ce74a6c8.jpeg",
    "https://cdn.faire.com/fastly/a6d4b0444aebdcdcfb8b233cf51db4c718c848646f4cda9d2631fcce4171eb0f.jpeg",
    "https://cdn.faire.com/fastly/9e4dba47f41e853d3ea8614616f2d591676c5bd691d93cc00a2f066e65801171.jpeg",
    "https://cdn.faire.com/fastly/315a5f85a34268dccfde5e6eb23768146784e0a821ec6274735c9ca57695901c.jpeg",
    "https://cdn.faire.com/fastly/14e6fe6966659c8c2210d8505302af36fff609ce51306e0b8d512308285918e0.jpeg",
    "https://cdn.faire.com/fastly/4febb51e08e828659b840d280d46abb44bb2f1640f87c5cc3756807a399d2b57.jpeg",
    "https://cdn.faire.com/fastly/9c448239cd6b5ea05a3b5b08545efaa013cb404cbd617c1022d3f7d7153775fa.jpeg",
    "https://cdn.faire.com/fastly/30103141ad825ad5c5feb980f09dd3fcf3c8d3fb9edd644fd7ea2c225f094ccb.png",
  ],
  priceDollars: 38.39,
  description:
    "*FEATURES: Medium Weight Fabric/Collared Neckline/Long Sleeves/Light Padding at the Shoulders/Decorative Pockets/Open-Front/Relaxed Bodice\n*LINED\n*COLOR: GREEN/APRICOT/ROSE PINK/LIGHT BLUE/RED/EARTH YELLOW/PEACH/BLACK/DARK BLUE \n*SIZE: S/M/L/XL\n*STYLE: 70347\n*Support individual sizes and individual pieces.\n*2-5 days processing time.\n*Made in China.\n*Due to the style differences, please check out the last image for the size chart of this style.",
  tags: [],
  msrpDollars: 76.77,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:22.437Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
